module.exports = __webpack_public_path__ + "static/img/activity-dialog-title-default.125b5bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/activity/three-order-activity/activity-dialog-title-default.png
// module id = 6DaZ
// module chunks = 4